import request from '@/router/axios';

// 查询配件列表 - 分页查询（兼容 crud-mixins 传入的 page/size）
export const getList = (params) => {
  const data = { ...params };
  if (data.page != null && data.current == null) {
    data.current = data.page;
    delete data.page;
  }
  return request({
    url: '/api/produce/base-spare-part-manage/select/page',
    method: 'post',
    data
  })
}

// 获取配件详情 - 根据ID查询
export const getDetail = (id) => {
  return request({
    url: '/api/produce/base-spare-part-manage/select/id',
    method: 'get',
    params: { id }
  })
}

// 新增配件
export const add = (row) => {
  return request({
    url: '/api/produce/base-spare-part-manage/insert',
    method: 'post',
    data: row
  })
}

// 修改配件
export const update = (row) => {
  return request({
    url: '/api/produce/base-spare-part-manage/update',
    method: 'post',
    data: row
  })
}

// 删除配件 - 单条删除
export const remove = (id) => {
  return request({
    url: '/api/produce/base-spare-part-manage/delete/id',
    method: 'post',
    params: { id }
  })
}

// 批量删除配件
export const removeBatch = (ids) => {
  return request({
    url: '/api/produce/base-spare-part-manage/delete/ids',
    method: 'post',
    params: { ids }
  })
}

// 库存变动（盘点/出入库）
export const changeStock = (row) => {
  return request({
    url: '/api/produce/base-spare-part-manage/count/change',
    method: 'post',
    data: row
  })
}

// Excel导入
export const importExcel = (file, params) => {
  const formData = new FormData();
  formData.append('file', file);
  if (params) {
    Object.keys(params).forEach(key => {
      formData.append(key, params[key]);
    });
  }
  return request({
    url: '/api/produce/base-spare-part-manage/upload/excel',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const downloadImportTemplate = () => {
  return request({
    url: '/api/produce/base-spare-part-manage/export/import-template',
    method: 'get',
    responseType: 'blob'
  })
}

// 配件入库（使用库存变动接口）
export const inbound = (row) => {
  return changeStock({
    id: row.id,
    stockCount: (row.stockCount || 0) + (row.inboundCount || 0),
    changeReason: `入库：${row.inboundCount || 0}`
  })
}

// 配件出库（使用库存变动接口）
export const outbound = (row) => {
  return changeStock({
    id: row.id,
    stockCount: Math.max(0, (row.stockCount || 0) - (row.outboundCount || 0)),
    changeReason: `出库：${row.outboundCount || 0}`
  })
}

// 获取设备列表（用于选择关联设备）
export const getDeviceList = (params) => {
  return request({
    url: '/api/produce/base-device-manage/select/page',
    method: 'post',
    params
  })
}

// 导出 Excel（筛选条件与列表查询一致，不分页导出全部匹配行）
export const exportExcel = (params) => {
  const data = { ...params }
  if (data.page != null && data.current == null) {
    data.current = data.page
    delete data.page
  }
  return request({
    url: '/api/produce/base-spare-part-manage/export/excel',
    method: 'post',
    data,
    responseType: 'blob'
  })
}

export function getFlowConfig() {
  return request({
    url: '/api/produce/base-spare-part-apply-flow-config/active',
    method: 'get',
  })
}

export function saveFlowConfig(data) {
  return request({
    url: '/api/produce/base-spare-part-apply-flow-config/save',
    method: 'post',
    data,
  })
}
